import { cva, type VariantProps } from 'class-variance-authority';

/**
 * LogoBox — fixed-dimension wrapper for school/brand logos (HEN tokens: logo-box, logo-box-sm).
 */
export const logoBoxVariants = cva(
  'flex shrink-0 items-center justify-center overflow-hidden rounded-xs bg-white',
  {
    variants: {
      size: {
        default: 'h-logo-box w-logo-box',
        sm: 'h-logo-box-sm w-logo-box-sm',
        fill: 'h-full w-full min-h-0 min-w-0 max-h-full max-w-full flex-1 shrink',
      },
      shadow: {
        sm: 'shadow-sm',
        none: 'shadow-none',
      },
    },
    defaultVariants: {
      size: 'default',
      shadow: 'sm',
    },
  },
);

export type LogoBoxVariantProps = VariantProps<typeof logoBoxVariants>;
